var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQualification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fab29b;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32,
    y: 13,
    width: 374,
    height: 291,
    rx: 25,
    ry: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M448,25.5H80.1c-16.9,0-30.6,13.7-30.6,30.6v257.4s0,0,0,0H8.1c-3.6,0-6.6,2.9-6.6,6.6,0,16.8,13.7,30.4,30.5,30.4h233.4s0,0,0,0v97.1c0,3.6,2.8,6.8,6.5,6.8s3.4-.7,4.6-1.9l43.4-43.4s0,0,0,0l43.4,43.4c1.2,1.2,2.9,1.9,4.6,1.9h0c.8,0,1.7-.2,2.5-.5,2.4-1,4-3.4,4-6v-97.4s0,0,0,0h25.4c16.9,0,30.6-13.7,30.6-30.6V62.6s0,0,0,0h41.4c3.6,0,6.6-2.9,6.6-6.6,0-16.8-13.7-30.4-30.5-30.4ZM421.7,40.8c-2.7,4.6-4.2,9.9-4.2,15.2v257.4s0,0,0,0h-25.4c-3.6,0-6.5,2.9-6.5,6.5h0c0,3.6,2.9,6.5,6.5,6.5h24.3c0,0,0,0,0,.1l-1.2,2.1c-3.1,5.4-8.9,8.8-15.2,8.8h-25.4s0,0,0,0v-1.4c0-3.6-2.9-6.5-6.5-6.5h0c-3.6,0-6.5,2.9-6.5,6.5v96.1c0,0,0,0-.1,0l-36.8-36.8c-2.5-2.5-6.7-2.5-9.2,0l-36.8,36.8s-.1,0-.1,0v-96.1c0-3.6-2.9-6.5-6.5-6.5h0c-3.6,0-6.5,2.9-6.5,6.5v1.4s0,0,0,0H32c-6.2,0-12-3.4-15.2-8.8l-1.2-2.1s0-.1,0-.1h232.3c3.6,0,6.5-2.9,6.5-6.5h0c0-3.6-2.9-6.5-6.5-6.5H62.6s0,0,0,0V56.1c0-9.7,7.9-17.6,17.6-17.6h342.9c0,0,0,0,0,.1l-1.3,2.2ZM431.7,49.5c0,0,0,0,0-.1l1.2-2.1c2.4-4,6.1-6.9,10.6-8.1,4.5-1.2,9.2-.6,13.3,1.8,2.6,1.5,4.8,3.7,6.4,6.4l1.2,2.1s0,.1,0,.1h-32.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.1,275.1h0s-10.7-19.1-10.7-19.1l10.7-19.1c1.8-3.1.6-7.1-2.5-8.8-.2,0-.3-.2-.5-.2l-19.9-9.1-2.6-21.7c-.2-1.7-1.1-3.3-2.4-4.3-1.4-1.1-3.1-1.5-4.8-1.3-.2,0-.3,0-.5,0l-21.5,4.2-14.8-16.1c-2.6-2.6-6.9-2.7-9.5,0l-14.9,16.1-21.5-4.2c-1.7-.3-3.4,0-4.9,1-1.4,1-2.4,2.4-2.8,4.1,0,.2,0,.3,0,.5l-2.6,21.7-19.9,9.1c-3.3,1.5-4.7,5.3-3.2,8.6,0,.2.2.3.2.5l10.7,19.1-10.7,19.1c-1.8,3.1-.6,7.1,2.5,8.8.2,0,.3.2.5.2l19.9,9.1,2.6,21.7c.4,3.6,3.7,6.1,7.2,5.7.2,0,.3,0,.5,0l21.5-4.2,14.8,16.1c2.4,2.6,6.6,2.8,9.2.3.1-.1.2-.2.4-.3l14.8-16.1,21.5,4.2c1.8.4,3.6,0,5.1-1.1,1.4-1.1,2.4-2.7,2.6-4.5l2.6-21.7,19.9-9.1c1.6-.7,2.8-2,3.4-3.7.6-1.6.5-3.4-.2-5,0-.2-.2-.3-.2-.5ZM370.3,259.2l9,16.1-16.8,7.7c-2,.9-3.5,2.9-3.7,5.2l-2.2,18.3-18.1-3.6c-2.2-.5-4.5.3-6,1.9l-12.5,13.6-12.5-13.6c-1.2-1.3-3-2.1-4.8-2.1-.4,0-.8,0-1.2.1l-18.1,3.6-2.2-18.3c-.3-2.2-1.7-4.2-3.8-5.2l-16.8-7.7,9-16.1c1-1.9,1.1-4,.3-5.9l-.3-.5-9-16.1,16.8-7.7c2-.9,3.5-2.9,3.7-5.1l2.2-18.4,18.1,3.6c2.2.5,4.5-.3,6-2l12.5-13.6,12.5,13.6c1.5,1.7,3.8,2.4,6,1.9l18.1-3.6,2.2,18.3c.3,2.2,1.7,4.2,3.8,5.2l16.8,7.7-9,16.1c-1.1,2-1.1,4.4,0,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320,217.5c-21.2,0-38.5,17.3-38.5,38.5,0,21.2,17.3,38.5,38.5,38.5,21.2,0,38.5-17.3,38.5-38.5s-17.3-38.5-38.5-38.5ZM320,281.5c-14.1,0-25.5-11.4-25.5-25.5s11.4-25.5,25.5-25.5,25.5,11.4,25.5,25.5-11.4,25.5-25.5,25.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 177.5,
    y: 73.5,
    width: 125,
    height: 13,
    rx: 6.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.5,
    y: 121.5,
    width: 285,
    height: 13,
    rx: 6.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.5,
    y: 153.5,
    width: 285,
    height: 13,
    rx: 6.5,
    ry: 6.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.5,
    y: 257.5,
    width: 101,
    height: 13,
    rx: 6.5,
    ry: 6.5
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQualification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Qualification.7a3854ae553bd0e37cf7e770e3bd179a.svg";